import BaseAPI from './BaseAPI';
import ServiceApiUrlsStore from '../stores/ServiceApiUrlsStore';

class JobAPIWrapper {
  constructor(api) {
    this.api = api;
  }

  allForOrg(orgId) {
    return this.api.get(`/orgs/${orgId}/jobs/giraffe`)
      .then(data => data.body.jobs);
  }

  all() {
    return this.api.get('/job/giraffe/all')
      .then(data => data.body.jobs);
  }

  get(id) {
    return this.api.get(`/job/giraffe/${id}`)
      .then(data => data.body.job);
  }

  getLogs(id) {
    return this.api.get(`/job/giraffe/${id}/logs`)
      .then(data => data.body.logs);
  }

  create(job) {
    return this.api.post('/job/giraffe', job)
      .then(data => ({ config: job, id: data.body.jobId }));
  }
}

class JobAPI extends BaseAPI {
  constructor(token) {
    super(ServiceApiUrlsStore.getJobServiceUrl(), token);
    this.jobs = new JobAPIWrapper(this);
  }
}

export default JobAPI;
